import React from 'react';

import RadioButton from 'components/RadioButton';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { HotelsResultRequestOrderCriteriaEnum } from 'models/hotelsSearch';

import { Container, OptionName } from './styles';

interface Props {
  value: HotelsResultRequestOrderCriteriaEnum;
  onChange: (value: HotelsResultRequestOrderCriteriaEnum) => void;
}

const Order = ({ value, onChange }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <section>
      <Container>
        <RadioButton
          value={HotelsResultRequestOrderCriteriaEnum.RECOMENDATION}
          optionValue={value}
          handleChangeValue={(value) => onChange(value)}
        />
        <OptionName>{t('hotelsFilters.order.recommended')}</OptionName>
      </Container>
      <Container>
        <RadioButton
          value={HotelsResultRequestOrderCriteriaEnum.PRICE}
          optionValue={value}
          handleChangeValue={(value) => onChange(value)}
        />
        <OptionName onClick={() => onChange(HotelsResultRequestOrderCriteriaEnum.PRICE)}>
          {t('hotelsFilters.order.price')}
        </OptionName>
      </Container>
      <Container>
        <RadioButton
          value={HotelsResultRequestOrderCriteriaEnum.CATEGORY}
          optionValue={value}
          handleChangeValue={(value) => onChange(value)}
        />
        <OptionName onClick={() => onChange(HotelsResultRequestOrderCriteriaEnum.CATEGORY)}>
          {t('hotelsFilters.order.stars')}
        </OptionName>
      </Container>
    </section>
  );
};

export default Order;
